export enum ASK_AI_CONFIGURATIONS {
    /**
     * @value Set as default for all sites
     * @description Label displayed in the ask ai configuration screen to set the configuration as default for all sites.
     */
    APPLY_AS_DEFAULT_FOR_ALL_SITES = 'ASK_AI_CONFIGURATION.APPLY_AS_DEFAULT_FOR_ALL_SITES',
    /**
     * @value Configurations
     * @description Allow to set specific sites and groups of users that are able to use ask ai.
     * Plural version
     */
    CONFIGURATIONS = 'ASK_AI_CONFIGURATIONS.CONFIGURATIONS',
    /**
     * @value A configuration is already set as default for all sites.
     * @description Notification displayed when a user tries to save a configuration to all sites when another one is already set on all sites.
     */
    CONFIGURATION_ALREADY_SET_AS_DEFAULT = 'ASK_AI_CONFIGURATION.CONFIGURATION_ALREADY_SET_AS_DEFAULT',
    /**
     * @value Configuration created.
     * @description Notification displayed when creating a new ask ai configuration
     */
    CONFIGURATION_CREATED_NOTIFICATION = 'ASK_AI_CONFIGURATIONS.CONFIGURATION_CREATED_NOTIFICATION',
    /**
     * @value Configuration deleted
     */
    CONFIGURATION_DELETED_NOTIFICATION = 'ASK_AI_CONFIGURATIONS.CONFIGURATION_DELETED_NOTIFICATION',
    /**
     * @value Configuration saved.
     * @description Notification displayed when editing an ask ai configuration
     */
    CONFIGURATION_EDITED_NOTIFICATION = 'ASK_AI_CONFIGURATIONS.CONFIGURATION_EDITED_NOTIFICATION',
    /**
     * @value Deleting the configuration %TITLE% is irreversible. You will delete the entire configuration.
     */
    CONFIRM_DELETE_CONFIGURATION = 'ASK_AI_CONFIGURATIONS.CONFIRM_DELETE_CONFIGURATION',
    /**
     * @value Delete configuration?
     */
    DELETE_CONFIGURATION = 'ASK_AI_CONFIGURATIONS.DELETE_CONFIGURATION',
    /**
     * @value Edit configuration
     * @description Header when editing ask ai configuration
     */
    EDIT_CONFIGURATION = 'ASK_AI_CONFIGURATIONS.EDIT_CONFIGURATION',
    /**
     * @value Activate Ask AI by creating your first configuration.
     * @description Description  for the empty state of ask ai configuration admin page
     */
    EMPTY_STATE_DESCRIPTION = 'ASK_AI_CONFIGURATIONS.EMPTY_STATE_DESCRIPTION',
    /**
     * @value No configurations yet
     * @description Title for the empty state of ask ai configuration admin page
     */
    EMPTY_STATE_TITLE = 'ASK_AI_CONFIGURATIONS.EMPTY_STATE_TITLE',
    /**
     * @value You can add only one Ask AI configuration per site.
     */
    FORM_ALREADY_USED_SITES_ERROR = 'ASK_AI_CONFIGURATIONS.FORM_ALREADY_USED_SITES_ERROR',
    /**
     * @value Describe the configuration.
     * @description Description for the general section of the ask ai configuration creation form
     */
    FORM_GENERAL_SECTION_DESCRIPTION = 'ASK_AI_CONFIGURATIONS.FORM_GENERAL_SECTION_DESCRIPTION',
    /**
     * @value Restrict to specific groups
     */
    FORM_GROUPS_PLACEHOLDER = 'ASK_AI_CONFIGURATIONS.FORM_GROUPS_PLACEHOLDER',
    /**
     * @value Remove the sites which already have a configuration.
     */
    FORM_REMOVE_SITES = 'ASK_AI_CONFIGURATIONS.FORM_REMOVE_SITES',
    /**
     * @value Choose where to deploy this configuration.
     */
    FORM_VISIBILITY_SECTION = 'ASK_AI_CONFIGURATIONS.FORM_VISIBILITY_SECTION',
    /**
     * @value Limit the configuration to a specific site selection
     * @description Error displayed in the ask ai configuration when a user tries to set a configuration as default when another one is already set as default.
     */
    LIMIT_THE_CONFIGURATION_TO_SPECIFIC_SITE_SELECTION = 'ASK_AI_CONFIGURATION.LIMIT_THE_CONFIGURATION_TO_SPECIFIC_SITE_SELECTION',
    /**
     * @value Limit to specific site selection
     * @description Label displayed in the ask ai configuration screen to select a specific list of sites on which to set the configuration.
     */
    LIMIT_TO_SPECIFIC_SITE_SELECTION = 'ASK_AI_CONFIGURATION.LIMIT_TO_SPECIFIC_SITE_SELECTION',
    /**
     * @value New configuration
     * @description Header for new ask ai configuration
     */
    NEW_CONFIGURATION = 'ASK_AI_CONFIGURATIONS.NEW_CONFIGURATION',
    /**
     * @value New configuration
     * @description Button label for creating new ask ai configuration
     */
    NEW_CONFIGURATION_BUTTON_LABEL = 'ASK_AI_CONFIGURATIONS.NEW_CONFIGURATION_BUTTON_LABEL',
}
